export type TeamModel = {
  cache_key: number,
  cover_image_id?: number,
  default?: boolean,
  description: string,
  id: number,
  image_library_id?: number,
  lead_agent_member_id?: number,
  owner_id: number,
  owner_type: string,
  team_members?: number[],
  team_member_count?: number,
  title: string,
  user_ids?: number[],
}

export type TeamRequestOptions = {}

const state = {
  description: '',
  id: null,
  owner_id: undefined,
  owner_type: '',
  title: '',
}

export const requiredFields = [
  { key: 'title' },
]

export default state
